import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import HeaderBar from 'header-bar'

const useStyles = makeStyles({
    root: {
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        width: '100%',
        background: '#F2F1F199',
        '&.small-view': {
            background: '#fff !important'
        }
    },
    header: {
        position: 'relative'
    },
    headerTitle: {
        fontSize: 16,
        fontWeight: 600,
        left: '50%',
        pointerEvents: 'none',
        position: 'absolute',
        top: '50%',
        transform: 'translate(-50%, -50%)'
    },
    beforeChildren: {
        marginTop: 20
    },
    content: {
        alignItems: 'center',
        display: 'flex',
        flex: 1,
        justifyContent: 'center',
        minHeight: 0,
        width: '100%'
    }
})

interface EmptyStateScreenProps {
    children: React.ReactNode
    beforeChildren?: React.ReactNode
    headerTitle: string
    onBack: () => void
    smallView?: boolean
}

const SmallViewBackIcon = (): JSX.Element => (
    <svg
        data-testid='empty-state-back-icon'
        fill='none'
        height='24'
        viewBox='0 0 24 24'
        width='24'
        xmlns='http://www.w3.org/2000/svg'
    >
        <path
            d='M9.33525 11.9955L14.8451 17.4998C15.2359 17.8903 15.2361 18.5237 14.8454 18.9144L14.7071 19.0527C14.3166 19.4432 13.6834 19.4432 13.2929 19.0527L6.9428 12.7026C6.55227 12.312 6.55227 11.6789 6.9428 11.2883L13.2929 4.93825C13.6834 4.54773 14.3166 4.54773 14.7071 4.93825L14.8454 5.07655C15.2361 5.46721 15.2359 6.10065 14.8451 6.49111L9.33525 11.9955Z'
            fill='#30991C'
        />
    </svg>
)

/**
 * Shared page shell for application empty states.
 */
export const EmptyStateScreen = ({
    children,
    headerTitle,
    onBack,
    beforeChildren,
    smallView = false
}: EmptyStateScreenProps): JSX.Element => {
    const classes = useStyles()

    return (
        <div className={`${classes.root} ${smallView ? 'small-view' : ''}`}>
            <div className={classes.header} data-testid='empty-state-header'>
                <HeaderBar
                    backButtonIcon={smallView ? <SmallViewBackIcon /> : undefined}
                    returnFnc={onBack}
                    smallView={smallView}
                >
                    <div />
                </HeaderBar>
                {smallView && <div className={classes.headerTitle}>{headerTitle}</div>}
            </div>
            {beforeChildren ? <div className={classes.beforeChildren}>{beforeChildren}</div> : null}
            <div className={classes.content}>{children}</div>
        </div>
    )
}
